import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-select-query-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_form_select = _resolveComponent("form-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_form_select, {
      class: "space-v1 item-value-input",
      "model-value": (_ctx.type === 'select' && _ctx.createable && !_ctx.activeOptions?.length) ? [] : _ctx.activeItems,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => { _ctx.activeItems = $event; _ctx.update($event) }),
      options: _ctx.activeOptions || [],
      type: (_ctx.type === 'multi' && _ctx.createable) || (_ctx.type === 'select' && _ctx.createable && !_ctx.activeOptions?.length) ? 'tag' : _ctx.type,
      label: _ctx.label || '',
      placeholder: _ctx.placeholder,
      onSelect: _cache[1] || (_cache[1] = e => e.value === true && _ctx.createable ? _ctx.handleCreate(null) : undefined),
      onInput: _cache[2] || (_cache[2] = e => _ctx.updateQueryString(e.data)),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.queryString = '')),
      onTag: _ctx.handleCreate
    }, {
      default: _withCtx(() => [
        _createVNode(_component_spinner, {
          visible: _ctx.loading,
          scale: .5,
          style: {"width":"50px"}
        }, null, 8, ["visible"])
      ]),
      _: 1
    }, 8, ["model-value", "options", "type", "label", "placeholder", "onTag"])
  ]))
}